import * as React from 'react'
import styled from 'styled-components'
import MobileBack from 'svgIcons/MobileBack'

type TProps = {
  onClose?: () => void
  title?: string
}

const MobileHeader: React.FC<TProps> = ({ onClose, title }) => {
  return (
    <StyledWrapper>
      <div className="search-header">
        <div className="back-btn" onClick={onClose}>
          <MobileBack />
        </div>
        <div className="header-title">{title}</div>
      </div>
    </StyledWrapper>
  )
}

export default MobileHeader

const StyledWrapper = styled.div`
  background-color: white;
  .search-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    .back-btn {
      position: absolute;
      top: 17px;
      left: 20px;
      cursor: pointer;
    }
    .header-title {
      font-size: 16px;
      font-weight: bold;
    }
  }
`
